var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 26,
    viewBox: "0 0 42 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18061_5044)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0762 23.1707H26.2518V2.77362H15.0762V23.1707Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7861 12.9721C15.7861 8.83407 17.6938 5.14858 20.6644 2.77361C18.4917 1.03644 15.7506 0.00012207 12.7711 0.00012207C5.71769 0.00012207 0 5.80799 0 12.9721C0 20.1363 5.71769 25.9442 12.7711 25.9442C15.7506 25.9442 18.4917 24.9079 20.6644 23.1707C17.6938 20.7954 15.7861 17.1102 15.7861 12.9721Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9296 21.0104V20.507H40.8002L40.6515 20.8533L40.5025 20.507H40.373V21.0104H40.4642V20.6306L40.604 20.9581H40.6987L40.8385 20.6298V21.0104H40.9296ZM40.1097 21.0104V20.5927H40.2758V20.5077H39.8536V20.5927H40.0193V21.0104H40.1097ZM41.3284 12.972C41.3284 20.1362 35.6104 25.9441 28.5573 25.9441C25.5778 25.9441 22.8364 24.9077 20.6641 23.1706C23.6347 20.7956 25.5423 17.1101 25.5423 12.972C25.5423 8.83431 23.6347 5.14881 20.6641 2.77349C22.8364 1.03632 25.5778 0 28.5573 0C35.6104 0 41.3284 5.80786 41.3284 12.972Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18061_5044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.4375,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.31e909a0930d5088a8afaded52af1a71.svg";
export { ForwardRef as ReactComponent };